import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { SharedService } from 'src/app/core/services/shared.service';
import { ToastService } from 'src/app/core/services/toast.service';
import * as CryptoJS from 'crypto-js';
import { UserService } from 'src/app/core/services/user.service';
import { WhiteSpaceValidator } from '../../validators/whiteSpaceValidator';

@Component({
  selector: 'app-edit-password',
  templateUrl: './edit-password.component.html',
  styleUrls: ['./edit-password.component.css']
})
export class EditPasswordComponent implements OnInit {

  passwordEditForm:FormGroup;
  submitForm = false;
  showPassword = false;
  wrongConfirmPassword = false;
  shortPassword = false;
  wrongOldPassword = false;
  user;
  isConfirmPasswordValid = false;

  constructor(private formBuilder:FormBuilder,
              private userService:UserService,
              private sharedService:SharedService,
              private toastService:ToastService,
              public dialogRef: MatDialogRef<EditPasswordComponent>) { 
    this.user = JSON.parse(localStorage.getItem('currentUser'));            
   }

  ngOnInit(): void {
    this.passwordEditForm = this.formBuilder.group({
      oldPassword: [undefined, [Validators.required,WhiteSpaceValidator.cannotContainSpace]],
      newPassword: [undefined, [Validators.required, WhiteSpaceValidator.cannotContainSpace]],
      confirmPassword: [undefined, [Validators.required, WhiteSpaceValidator.cannotContainSpace]]
    });
  }

  isConfirmCorrect(){
    if(this.passwordEditForm.get("newPassword").value != this.passwordEditForm.get("confirmPassword").value)
      this.wrongConfirmPassword = true;
  }

  isUnchangedPassword(){
    if(this.passwordEditForm.get("newPassword").value && this.passwordEditForm.get("newPassword").value!=undefined &&
    this.passwordEditForm.get("oldPassword").value == this.passwordEditForm.get("newPassword").value){
      return true;
    }
    return false;
  }

  isRequiredInSave(param){
    if(null != this.requiredInSave(param) && !this.requiredInSave(param)){
      this.isConfirmPasswordValid=true;
    }
  }


  requiredInSave(param){
    return this.passwordEditForm.get(param).errors && this.submitForm
  }

  getInputType(){
    if(this.showPassword)
      return 'text';
    else
      return 'password'
  }

  cancel(success?){
    this.dialogRef.close(success);
  }

  save(){
    this.submitForm = true;
    let param = this.passwordEditForm.getRawValue();
    let element = document.getElementsByClassName("invalid-field");
    setTimeout(() => {
      if ((element != null) && (element.length == 0)) {
        param["confirmPassword"] = undefined;
        param["oldPassword"] = CryptoJS.HmacSHA512(param["oldPassword"], 'Wevi@@2021').toString(CryptoJS.enc.Hex);
        param["newPassword"] = CryptoJS.HmacSHA512(param["newPassword"], 'Wevi@@2021').toString(CryptoJS.enc.Hex);
        param["userId"] = this.user["id"];
        this.userService.editPassword(param).subscribe(
          ()=>{
            this.toastService.showSuccess(this.sharedService.translate("SUCCESS_EDIT_PASSWORD"));
            this.cancel();
          },
          (err)=>{
            if(err.error.code == "USER_EDIT_NOT_AUTHORIZED"){
              this.wrongOldPassword = true;
            } 
            else{
              this.toastService.showError(this.sharedService.translate("TOAST.USER_CREATION_FAIL"))
            }
          }
        )
      }
    });
  }

  isPasswordShort(){
    if(this.passwordEditForm.get("newPassword").value.length < 8)
      this.shortPassword = true;
  }

  scrollToWrongElement() {
    let element = document.getElementsByClassName("invalid-field");
    setTimeout(() => {
      if ((element != null) && (element.length > 0)) {
        element[0].scrollIntoView({
          behavior: 'auto',
          block: 'center',
          inline: 'center'
        });
      }
    });
  }

}
